import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

type Props = {
  isModalOpen: boolean;
  isCarefully: boolean;
  handleToggleRegisterModal: () => void;
  handleChangeModal: (from: 'login' | 'register') => void;
  handleOauthsLinkClick: (provider: string) => void;
  lineIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({
  isModalOpen,
  isCarefully,
  handleToggleRegisterModal,
  handleChangeModal,
  handleOauthsLinkClick,
  lineIcon,
}) => {
  if (!isModalOpen) return null;

  const dataCategory = isCarefully ? 'register_carefully_popup' : 'register_popup'

  return (
    <div
      className={classnames('l-sign-up-modal', { 'is-active': isModalOpen })}
    >
      <div
        className="l-sign-up-modal-clickarea"
        onClick={handleToggleRegisterModal}
      />
      <div className="sign-up-modal gtm-popup-view-count" data-event-name='popup on screen' data-category={dataCategory} data-value='register'>
        <div className="sign-up-modal-container">
          <span className="sign-up-modal-heading">新規登録</span>
          <div className="sign-up-modal-inner">
            <ul className="sign-up-modal-button-list">
              {/* LINE */}
              <li className="sign-up-modal-button-item">
                <button
                  type="button"
                  className='sign-up-modal-button-link'
                  data-event="click"
                  data-category={dataCategory}
                  data-value="line"
                  onClick={() => handleOauthsLinkClick('line')}
                />
                <div className="login-modal-button-item-box login-modal-button-item-line btn">
                  <div className="login-modal-button-item-box-inner img">
                    <img
                      src={lineIcon}
                      alt="READY TO FASHION Line登録"
                      className="login-modal-button-item-box-inner-icon line"
                    />
                    <p className="login-modal-button-item-box-inner-text">LINE で今すぐ登録</p>
                  </div>
                </div>
              </li>

              {/* Apple */}
              <li className="sign-up-modal-button-item">
                <button
                  type="button"
                  className='sign-up-modal-button-link'
                  data-event="click"
                  data-category={dataCategory}
                  data-value="apple"
                  onClick={() => handleOauthsLinkClick('apple')}
                />
                <div className="login-modal-button-item-box login-modal-button-item-apple btn">
                  <div className="login-modal-button-item-box-inner">
                    <i className="fab fa-apple login-modal-button-item-box-inner-icon" />
                    <p className="login-modal-button-item-box-inner-text">Apple で今すぐ登録</p>
                  </div>
                </div>
              </li>

              {/* Mail */}
              <li className="sign-up-modal-button-item">
                <button
                  type="button"
                  className="sign-up-modal-button-link"
                  data-event="click"
                  data-category={dataCategory}
                  data-value="mail"
                  onClick={() => handleOauthsLinkClick('mail')}
                />
                <div className="login-modal-button-item-box login-modal-button-item-mail btn">
                  <div className="login-modal-button-item-box-inner">
                    <i className="fas fa-envelope login-modal-button-item-box-inner-icon" />
                    <p className="login-modal-button-item-box-inner-text">メールアドレスで登録</p>
                  </div>
                </div>
              </li>
            </ul>

            <p className="login-modal-gray">その他</p>
            <div className="login-modal-others">
              <a
                onClick={() => handleChangeModal('register')}
                className="right"
                data-event="click"
                data-category={dataCategory}
                data-value="to_login"
              >
                アカウントをお持ちの方はこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
